const axios = require('axios');
const { getContracts } = require('./utils.js');

const _getRegistry = async (signer) => (await getContracts(signer)).reporterRegistry;

const _registerReporter = async (signer) => {
    const registry = await _getRegistry(signer);

    return registry.registerReporter();
}

const _ragequitReporter = async (signer) => {
    const registry = await _getRegistry(signer);

    return registry.ragequitReporter();
}

const _isReporterRegistered = async (signer, reporter) => {
    const registry = await _getRegistry(signer);

    return registry.isReporterOperational(reporter);
}

const _scanForPBSViolations = async (host, epoch) => {
    try {
       let response = await axios.get(`${host}/scan?epoch=${epoch}`)
        return response.data;
    } catch (e) {
        console.log(`_scanForPBSViolations: Failed to scan via URL: ${host}/scan?epoch=${epoch}`)
        return null
    }
}
const _verifyPBSViolations = async (host, penalties) => {
    let response = await axios.post(`${host}/validate`, {
        reports: penalties
    });
    return response.data;
}

const _report = async (signer, reports, withdraw) => {
    const registry = await _getRegistry(signer);
    return registry.batchSubmitReport(
        reports.reports,
        reports.designatedVerifierSignatures,
        Array(reports.designatedVerifierSignatures.length).map(() => withdraw)
    )
}

class ReporterRegistry {

    constructor(signer) {
        this.signer = signer;
    }

    getRegistry() {
        return _getRegistry(this.signer);
    }

    registerReporter() {
        return _registerReporter(this.signer);
    }

    ragequitReporter() {
        return _ragequitReporter(this.signer);
    }

    isReporterRegistered(reporter) {
        return _isReporterRegistered(this.signer, reporter);
    }

    scanForPBSViolations(host, epoch) {
        return _scanForPBSViolations(host, epoch)
    }

    verifyPBSViolations(host, penalties) {
        return _verifyPBSViolations(host, penalties);
    }

    report(reports, withdraw) {
        return _report(this.signer, reports, withdraw);
    }
}

module.exports = ReporterRegistry;